
import ChbFooter from '@/layout/chb-footer.vue';

export default {
  name: 'index',
  components: { ChbFooter },
  data() {
    return {
      includeComponents: []
    };
  },
  watch: {},
  created() {
    // 在组件创建时计算 include 属性并存储在 includeComponents 中
    this.includeComponents = this.getInclude();
  },
  methods: {
    getInclude() {
      // 初始化一个空数组来存储需要缓存的组件名称
      let includeComponents = [];
      // 遍历路由配置中的每个路由
      this.$router.options.routes.forEach((item) => {
        // 如果路由的 meta 中的 keepAlive 为 true，则将该路由的名称添加到 includeComponents 数组中
        if (item.meta && item.meta.keepAlive) {
          includeComponents.push(item.name);
        }
        item.children?.forEach((child) => {
          if (child.meta && child.meta.keepAlive) {
            includeComponents.push(child.name);
          }
        });
      });

      // 返回 includeComponents 数组，以包含在 <keep-alive> 的 include 属性中
      return includeComponents;
    }
  }
};
